import type { ExportRenderQualityId } from '@/rendering/export/types'
import type { RenderFrameAtTimeFn } from '@/rendering/renderFrameAtTime'

/**
 * 离线导出时的视口视觉选项（与预览编辑分离）。
 */
export type ExportVisualSessionOptions = {
  /** 为 true 时关闭选中高亮等编辑器辅助层 */
  suppressEditorOverlay: boolean
  /** 质量档位，映射到 WebGLRenderer 等参数 */
  quality: ExportRenderQualityId
}

/**
 * 由 `ImockupThreeViewport` 挂载，供导出静态图/视频时调用渲染，无需经过 Pinia 时间跳转。
 */
export type ViewportExportApi = {
  /** 将场景渲染到指定全局时间（秒）并 `renderer.render` */
  renderFrameAtTime: RenderFrameAtTimeFn
  getCanvas: () => HTMLCanvasElement | null
  /**
   * 将 WebGL 绘制缓冲对齐到场景逻辑像素（与比例预设 / 宽高输入一致），用于导出。
   * 必须与 {@link endSceneCanvasSize} 成对调用（建议 `try/finally`）。
   *
   * @param width - 目标像素宽（≥1）
   * @param height - 目标像素高（≥1）
   */
  beginSceneCanvasSize: (width: number, height: number) => void
  /** 恢复为视口宿主尺寸并重新执行布局 `resize`。 */
  endSceneCanvasSize: () => void
  /**
   * 开始导出视觉会话（与 `beginSceneCanvasSize` 独立，可先于画布尺寸调用）。
   * 与 {@link endExportVisualSession} 成对、可嵌套（仅最外层生效）。
   */
  beginExportVisualSession: (opts: ExportVisualSessionOptions) => void
  /** 结束导出视觉会话，恢复编辑器辅助层与渲染质量。 */
  endExportVisualSession: () => void
}

let api: ViewportExportApi | null = null

export function setViewportExportApi(next: ViewportExportApi | null): void {
  api = next
}

export function getViewportExportApi(): ViewportExportApi | null {
  return api
}
